
export default {
    getPoolsfromInMem(state){
        return state.pools
    },
    getPoolDevicesfromInMem(state){
        return state.pool_devices
    },
    // getDefaultPoolfromInMem(state){
    //     for (const pool of Object.values(state.pools)) {
    //         if (pool.default){
    //             return pool
    //         }
    //     }
    //     if (Object.values(state.pools).length){
    //         return Object.values(state.pools)[0]
    //     }
    // }
};
